export default __webpack_public_path__ + "static/media/favicon.6c983f1c.png";